export default __webpack_public_path__ + "static/media/mountain.ddcab061.svg";